import React from 'react';
import PropTypes from 'prop-types';

const Company = (props) => {
  // Formats the time. Shows minutes only if they're not zero.
  function formatTime(time) {
    const times = [time.substring(0, 2), time.substring(2, 4)];
    let formattedTime = times[0];

    if (times[1] !== '00') {
      formattedTime += `:${times[1]}`;
    }

    return formattedTime;
  }

  return (
    <div className="list__content">
      <div className="opening-hours-content__container">
        <p className="today-page__opening_hours-company--title">
          {props.title}
        </p>
        <p className="today-page__opening_hours-company--hours">
          {formatTime(props.openingHours.open)}-
          {formatTime(props.openingHours.close)}
        </p>
      </div>
    </div>
  );
};

Company.propTypes = {
  title: PropTypes.string,
  website: PropTypes.string,
  openingHours: PropTypes.shape({
    close: PropTypes.string,
    open: PropTypes.string,
  }),
};

export default Company;
